import { css, keyframes } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';

const playerViewStyles = css`
  height: fit-content;
`;

export const PLAYER_CLASSNAME = cn('w-full', playerViewStyles);

export const fullPagePlayerViewStyles = css`
  margin-top: 10%;
  margin-bottom: 10%;
  @media ${BREAKPOINT_QUERIES.Mobile} {
    margin-top: 0%;
    margin-bottom: 0%;
  }
`;

const contentStyles = cn('max-w-[55.2rem] mx-auto xs:px-20', fullPagePlayerViewStyles);

export const FULL_PAGE_PLAYER_CLASSES = {
  player: 'flex-1 overflow-y-auto',
  preview: contentStyles,
  question: contentStyles,
  emptyState: contentStyles,
};

const questionSlideKeyframes = keyframes`
  from {
    transform: translate3d(3.75rem, 0, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;

const reverseQuestionSlideKeyframes = keyframes`
  from {
    transform: translate3d(-3.75rem, 0, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;

export const questionSlideAnimation = css`
  animation: ${questionSlideKeyframes} 0.3s ease-out forwards;
  opacity: 0;
`;

export const reverseQuestionSlideAnimation = css`
  animation: ${reverseQuestionSlideKeyframes} 0.3s ease-out forwards;
  opacity: 0;
`;
